var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"scrolling-text-container",on:{"mouseenter":function($event){_vm.isHovering = true},"mouseleave":function($event){_vm.isHovering = false}}},[_c('span',{ref:"text",staticClass:"scrolling-text",class:{
      'scrolling-text--paused': _vm.isHovering && _vm.playAnimation
    },style:(_vm.cssAnimationStyles),on:{"animationend":function($event){return _vm.resetAnimation()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }